import { Component, OnDestroy, Signal } from '@angular/core';
import { ApplicationAppEntityApplicationRead } from '../../../../../../openapi';
import {
  selectApplication,
  selectLoading,
  selectPending
} from '../../../../../../store/selectors/application.selectors';
import { Subscription } from 'rxjs';
import { toObservable } from '@angular/core/rxjs-interop';
import { Store } from '@ngrx/store';
import { ActivatedRoute, Router } from '@angular/router';
import { updateApplication } from '../../../../../../store/actions/application.actions';
import { stages } from '../../opinion-of-conformity.routes';
import { InvestmentCharacteristicsForm } from './forms/investment-characteristics.form';
import { AlertComponent } from '../../../../../../common/alert/alert.component';
import {
  DrawAndModifyTerrainComponent
} from '../../../../../../common/draw-and-modify-terrain/draw-and-modify-terrain.component';
import { CommonModule } from '@angular/common';
import { NgxMaskDirective } from 'ngx-mask';
import { ReactiveFormsModule } from '@angular/forms';
import { SpinnerComponent } from '../../../../../../common/spinner/spinner.component';
import { StagesComponent } from '../../../../../../common/stages/stages.component';
import { ValidationErrorsComponent } from '../../../../../../common/validation-errors/validation-errors.component';

@Component({
  selector: 'app-investment-characteristics-section',
  standalone: true,
  imports: [
    AlertComponent,
    DrawAndModifyTerrainComponent,
    CommonModule,
    NgxMaskDirective,
    ReactiveFormsModule,
    SpinnerComponent,
    StagesComponent,
    ValidationErrorsComponent
  ],
  providers: [
    InvestmentCharacteristicsForm
  ],
  templateUrl: './investment-characteristics-section.component.html'
})
export class InvestmentCharacteristicsSectionComponent implements OnDestroy {

  public stages: string[] = stages;

  public applicationId: string = this.route.snapshot.params['appId'];

  public application: Signal<ApplicationAppEntityApplicationRead | null> = this.store$.selectSignal(selectApplication);

  public pending: Signal<boolean> = this.store$.selectSignal(selectPending);

  public loading: Signal<boolean> = this.store$.selectSignal(selectLoading);

  private fetchApplication: Subscription = toObservable(this.application).subscribe(app => {
    if (app) {
      this.form.patchFormValues(app);
    }
  });

  constructor(
    public form: InvestmentCharacteristicsForm,
    private store$: Store,
    private route: ActivatedRoute,
    private router: Router
  ) {
  }

  public onCancel(): void {
    this.router.navigate(['../dane-nieruchomosci'], { relativeTo: this.route });
  }

  public submitAndGoNext(): void {
    if (this.form.valid) {
      this.store$.dispatch(updateApplication({
        id: this.applicationId || '',
        application: this.form.toWriteModel(),
        successFnc: (applicationId: string) => {
          this.router.navigate(
            ['../zgody'],
            {
              relativeTo: this.route
            }
          );
        },
        failureFnc: () => {
        }
      }));
    } else {
      this.form.markAllAsTouched();
    }
  }

  public ngOnDestroy(): void {
    this.fetchApplication.unsubscribe();
  }
}
